




























































import Vue from 'vue';
import {api, months, shortMonths} from "@/ts/constants";
import CustomDialog from "@/components/CustomDialog.vue";
import SelectionInfo from "@/components/SelectionInfo.vue";
import AppBar from "@/components/AppBar.vue";

export default Vue.extend({
    name: 'App',
    components: {AppBar, SelectionInfo, CustomDialog},
    data: () => ({
        pages: [
            {name: 'Home', icon: 'mdi-home-outline', to: '/'},
            {name: 'Explore', icon: 'mdi-magnify', to: '/explore'},
            {name: 'Photo map', icon: 'mdi-earth', to: '/map'},
        ],
    }),
    async mounted() {
        if (!this.$store.getters.isLoggedIn && this.$route.name !== 'Login')
            await this.$router.push('/login');
        console.log(this.$store);
    },
    methods: {
        scrollToTop() {
            if (this.$route.name === 'Home') {
                this.$store.commit('scrollToTop', true);
            }
        },
        page() {
            return this.pages.findIndex(p => p.to === this.$route.path);
        },
    },
    watch: {
        '$vuetify.theme.dark'() {
            localStorage.darkTheme = this.$vuetify.theme.dark;
        },
    }
});
